function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
var matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;

var stringToIcon = function stringToIcon(value, validate, allowSimpleName) {
  var provider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var colonSeparated = value.split(":");

  if (value.slice(0, 1) === "@") {
    if (colonSeparated.length < 2 || colonSeparated.length > 3) {
      return null;
    }

    provider = colonSeparated.shift().slice(1);
  }

  if (colonSeparated.length > 3 || !colonSeparated.length) {
    return null;
  }

  if (colonSeparated.length > 1) {
    var name2 = colonSeparated.pop();
    var prefix = colonSeparated.pop();
    var result = {
      provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
      prefix: prefix,
      name: name2
    };
    return validate && !validateIconName(result) ? null : result;
  }

  var name = colonSeparated[0];
  var dashSeparated = name.split("-");

  if (dashSeparated.length > 1) {
    var _result = {
      provider: provider,
      prefix: dashSeparated.shift(),
      name: dashSeparated.join("-")
    };
    return validate && !validateIconName(_result) ? null : _result;
  }

  if (allowSimpleName && provider === "") {
    var _result2 = {
      provider: provider,
      prefix: "",
      name: name
    };
    return validate && !validateIconName(_result2, allowSimpleName) ? null : _result2;
  }

  return null;
};

var validateIconName = function validateIconName(icon, allowSimpleName) {
  if (!icon) {
    return false;
  }

  return !!((icon.provider === "" || icon.provider.match(matchIconName)) && (allowSimpleName && icon.prefix === "" || icon.prefix.match(matchIconName)) && icon.name.match(matchIconName));
};

var defaultIconDimensions = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16
});
var defaultIconTransformations = Object.freeze({
  rotate: 0,
  vFlip: false,
  hFlip: false
});
var defaultIconProps = Object.freeze(_objectSpread(_objectSpread({}, defaultIconDimensions), defaultIconTransformations));
var defaultExtendedIconProps = Object.freeze(_objectSpread(_objectSpread({}, defaultIconProps), {}, {
  body: "",
  hidden: false
}));

function mergeIconTransformations(obj1, obj2) {
  var result = {};

  if (!obj1.hFlip !== !obj2.hFlip) {
    result.hFlip = true;
  }

  if (!obj1.vFlip !== !obj2.vFlip) {
    result.vFlip = true;
  }

  var rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;

  if (rotate) {
    result.rotate = rotate;
  }

  return result;
}

function mergeIconData(parent, child) {
  var result = mergeIconTransformations(parent, child);

  for (var key in defaultExtendedIconProps) {
    if (key in defaultIconTransformations) {
      if (key in parent && !(key in result)) {
        result[key] = defaultIconTransformations[key];
      }
    } else if (key in child) {
      result[key] = child[key];
    } else if (key in parent) {
      result[key] = parent[key];
    }
  }

  return result;
}

function getIconsTree(data, names) {
  var icons = data.icons;
  var aliases = data.aliases || /* @__PURE__ */Object.create(null);
  var resolved = /* @__PURE__ */Object.create(null);

  function resolve(name) {
    if (icons[name]) {
      return resolved[name] = [];
    }

    if (!(name in resolved)) {
      resolved[name] = null;
      var parent = aliases[name] && aliases[name].parent;
      var value = parent && resolve(parent);

      if (value) {
        resolved[name] = [parent].concat(value);
      }
    }

    return resolved[name];
  }

  (names || Object.keys(icons).concat(Object.keys(aliases))).forEach(resolve);
  return resolved;
}

function internalGetIconData(data, name, tree) {
  var icons = data.icons;
  var aliases = data.aliases || /* @__PURE__ */Object.create(null);
  var currentProps = {};

  function parse(name2) {
    currentProps = mergeIconData(icons[name2] || aliases[name2], currentProps);
  }

  parse(name);
  tree.forEach(parse);
  return mergeIconData(data, currentProps);
}

function parseIconSet(data, callback) {
  var names = [];

  if (_typeof(data) !== "object" || _typeof(data.icons) !== "object") {
    return names;
  }

  if (data.not_found instanceof Array) {
    data.not_found.forEach(function (name) {
      callback(name, null);
      names.push(name);
    });
  }

  var tree = getIconsTree(data);

  for (var name in tree) {
    var item = tree[name];

    if (item) {
      callback(name, internalGetIconData(data, name, item));
      names.push(name);
    }
  }

  return names;
}

var optionalPropertyDefaults = _objectSpread({
  provider: "",
  aliases: {},
  not_found: {}
}, defaultIconDimensions);

function checkOptionalProps(item, defaults) {
  for (var prop in defaults) {
    if (prop in item && _typeof(item[prop]) !== _typeof(defaults[prop])) {
      return false;
    }
  }

  return true;
}

function quicklyValidateIconSet(obj) {
  if (_typeof(obj) !== "object" || obj === null) {
    return null;
  }

  var data = obj;

  if (typeof data.prefix !== "string" || !obj.icons || _typeof(obj.icons) !== "object") {
    return null;
  }

  if (!checkOptionalProps(obj, optionalPropertyDefaults)) {
    return null;
  }

  var icons = data.icons;

  for (var name in icons) {
    var icon = icons[name];

    if (!name.match(matchIconName) || typeof icon.body !== "string" || !checkOptionalProps(icon, defaultExtendedIconProps)) {
      return null;
    }
  }

  var aliases = data.aliases || /* @__PURE__ */Object.create(null);

  for (var _name in aliases) {
    var _icon = aliases[_name];
    var parent = _icon.parent;

    if (!_name.match(matchIconName) || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !checkOptionalProps(_icon, defaultExtendedIconProps)) {
      return null;
    }
  }

  return data;
}

var dataStorage = /* @__PURE__ */Object.create(null);

function newStorage(provider, prefix) {
  return {
    provider: provider,
    prefix: prefix,
    icons: /* @__PURE__ */Object.create(null),
    missing: /* @__PURE__ */new Set()
  };
}

function getStorage(provider, prefix) {
  var providerStorage = dataStorage[provider] || (dataStorage[provider] = /* @__PURE__ */Object.create(null));
  return providerStorage[prefix] || (providerStorage[prefix] = newStorage(provider, prefix));
}

function addIconSet(storage, data) {
  if (!quicklyValidateIconSet(data)) {
    return [];
  }

  return parseIconSet(data, function (name, icon) {
    if (icon) {
      storage.icons[name] = icon;
    } else {
      storage.missing.add(name);
    }
  });
}

function addIconToStorage(storage, name, icon) {
  try {
    if (typeof icon.body === "string") {
      storage.icons[name] = _objectSpread({}, icon);
      return true;
    }
  } catch (err) {}

  return false;
}

function listIcons(provider, prefix) {
  var allIcons = [];
  var providers = typeof provider === "string" ? [provider] : Object.keys(dataStorage);
  providers.forEach(function (provider2) {
    var prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [prefix] : Object.keys(dataStorage[provider2] || {});
    prefixes.forEach(function (prefix2) {
      var storage = getStorage(provider2, prefix2);
      allIcons = allIcons.concat(Object.keys(storage.icons).map(function (name) {
        return (provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name;
      }));
    });
  });
  return allIcons;
}

var simpleNames = false;

function allowSimpleNames(allow) {
  if (typeof allow === "boolean") {
    simpleNames = allow;
  }

  return simpleNames;
}

function getIconData(name) {
  var icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;

  if (icon) {
    var _storage = getStorage(icon.provider, icon.prefix);

    var iconName = icon.name;
    return _storage.icons[iconName] || (_storage.missing.has(iconName) ? null : void 0);
  }
}

function addIcon(name, data) {
  var icon = stringToIcon(name, true, simpleNames);

  if (!icon) {
    return false;
  }

  var storage = getStorage(icon.provider, icon.prefix);
  return addIconToStorage(storage, icon.name, data);
}

function addCollection(data, provider) {
  if (_typeof(data) !== "object") {
    return false;
  }

  if (typeof provider !== "string") {
    provider = data.provider || "";
  }

  if (simpleNames && !provider && !data.prefix) {
    var added = false;

    if (quicklyValidateIconSet(data)) {
      data.prefix = "";
      parseIconSet(data, function (name, icon) {
        if (icon && addIcon(name, icon)) {
          added = true;
        }
      });
    }

    return added;
  }

  var prefix = data.prefix;

  if (!validateIconName({
    provider: provider,
    prefix: prefix,
    name: "a"
  })) {
    return false;
  }

  var storage = getStorage(provider, prefix);
  return !!addIconSet(storage, data);
}

function iconExists(name) {
  return !!getIconData(name);
}

function getIcon(name) {
  var result = getIconData(name);
  return result ? _objectSpread(_objectSpread({}, defaultIconProps), result) : null;
}

var defaultIconSizeCustomisations = Object.freeze({
  width: null,
  height: null
});
var defaultIconCustomisations = Object.freeze(_objectSpread(_objectSpread({}, defaultIconSizeCustomisations), defaultIconTransformations));
var unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
var unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;

function calculateSize(size, ratio, precision) {
  if (ratio === 1) {
    return size;
  }

  precision = precision || 100;

  if (typeof size === "number") {
    return Math.ceil(size * ratio * precision) / precision;
  }

  if (typeof size !== "string") {
    return size;
  }

  var oldParts = size.split(unitsSplit);

  if (oldParts === null || !oldParts.length) {
    return size;
  }

  var newParts = [];
  var code = oldParts.shift();
  var isNumber = unitsTest.test(code);

  while (true) {
    if (isNumber) {
      var num = parseFloat(code);

      if (isNaN(num)) {
        newParts.push(code);
      } else {
        newParts.push(Math.ceil(num * ratio * precision) / precision);
      }
    } else {
      newParts.push(code);
    }

    code = oldParts.shift();

    if (code === void 0) {
      return newParts.join("");
    }

    isNumber = !isNumber;
  }
}

var isUnsetKeyword = function isUnsetKeyword(value) {
  return value === "unset" || value === "undefined" || value === "none";
};

function iconToSVG(icon, customisations) {
  var fullIcon = _objectSpread(_objectSpread({}, defaultIconProps), icon);

  var fullCustomisations = _objectSpread(_objectSpread({}, defaultIconCustomisations), customisations);

  var box = {
    left: fullIcon.left,
    top: fullIcon.top,
    width: fullIcon.width,
    height: fullIcon.height
  };
  var body = fullIcon.body;
  [fullIcon, fullCustomisations].forEach(function (props) {
    var transformations = [];
    var hFlip = props.hFlip;
    var vFlip = props.vFlip;
    var rotation = props.rotate;

    if (hFlip) {
      if (vFlip) {
        rotation += 2;
      } else {
        transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
        transformations.push("scale(-1 1)");
        box.top = box.left = 0;
      }
    } else if (vFlip) {
      transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
      transformations.push("scale(1 -1)");
      box.top = box.left = 0;
    }

    var tempValue;

    if (rotation < 0) {
      rotation -= Math.floor(rotation / 4) * 4;
    }

    rotation = rotation % 4;

    switch (rotation) {
      case 1:
        tempValue = box.height / 2 + box.top;
        transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        break;

      case 2:
        transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
        break;

      case 3:
        tempValue = box.width / 2 + box.left;
        transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        break;
    }

    if (rotation % 2 === 1) {
      if (box.left !== box.top) {
        tempValue = box.left;
        box.left = box.top;
        box.top = tempValue;
      }

      if (box.width !== box.height) {
        tempValue = box.width;
        box.width = box.height;
        box.height = tempValue;
      }
    }

    if (transformations.length) {
      body = '<g transform="' + transformations.join(" ") + '">' + body + "</g>";
    }
  });
  var customisationsWidth = fullCustomisations.width;
  var customisationsHeight = fullCustomisations.height;
  var boxWidth = box.width;
  var boxHeight = box.height;
  var width;
  var height;

  if (customisationsWidth === null) {
    height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    width = calculateSize(height, boxWidth / boxHeight);
  } else {
    width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
    height = customisationsHeight === null ? calculateSize(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
  }

  var attributes = {};

  var setAttr = function setAttr(prop, value) {
    if (!isUnsetKeyword(value)) {
      attributes[prop] = value.toString();
    }
  };

  setAttr("width", width);
  setAttr("height", height);
  attributes.viewBox = box.left.toString() + " " + box.top.toString() + " " + boxWidth.toString() + " " + boxHeight.toString();
  return {
    attributes: attributes,
    body: body
  };
}

var regex = /\sid="(\S+)"/g;
var randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
var counter = 0;

function replaceIDs(body) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : randomPrefix;
  var ids = [];
  var match;

  while (match = regex.exec(body)) {
    ids.push(match[1]);
  }

  if (!ids.length) {
    return body;
  }

  var suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  ids.forEach(function (id) {
    var newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
    var escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    body = body.replace(new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + suffix + "$3");
  });
  body = body.replace(new RegExp(suffix, "g"), "");
  return body;
}

var storage = /* @__PURE__ */Object.create(null);

function setAPIModule(provider, item) {
  storage[provider] = item;
}

function getAPIModule(provider) {
  return storage[provider] || storage[""];
}

function createAPIConfig(source) {
  var resources;

  if (typeof source.resources === "string") {
    resources = [source.resources];
  } else {
    resources = source.resources;

    if (!(resources instanceof Array) || !resources.length) {
      return null;
    }
  }

  var result = {
    resources: resources,
    path: source.path || "/",
    maxURL: source.maxURL || 500,
    rotate: source.rotate || 750,
    timeout: source.timeout || 5e3,
    random: source.random === true,
    index: source.index || 0,
    dataAfterTimeout: source.dataAfterTimeout !== false
  };
  return result;
}

var configStorage = /* @__PURE__ */Object.create(null);
var fallBackAPISources = ["https://api.simplesvg.com", "https://api.unisvg.com"];
var fallBackAPI = [];

while (fallBackAPISources.length > 0) {
  if (fallBackAPISources.length === 1) {
    fallBackAPI.push(fallBackAPISources.shift());
  } else {
    if (Math.random() > 0.5) {
      fallBackAPI.push(fallBackAPISources.shift());
    } else {
      fallBackAPI.push(fallBackAPISources.pop());
    }
  }
}

configStorage[""] = createAPIConfig({
  resources: ["https://api.iconify.design"].concat(fallBackAPI)
});

function addAPIProvider(provider, customConfig) {
  var config = createAPIConfig(customConfig);

  if (config === null) {
    return false;
  }

  configStorage[provider] = config;
  return true;
}

function getAPIConfig(provider) {
  return configStorage[provider];
}

function listAPIProviders() {
  return Object.keys(configStorage);
}

var detectFetch = function detectFetch() {
  var callback;

  try {
    callback = fetch;

    if (typeof callback === "function") {
      return callback;
    }
  } catch (err) {}
};

var fetchModule = detectFetch();

function setFetch(fetch2) {
  fetchModule = fetch2;
}

function getFetch() {
  return fetchModule;
}

function calculateMaxLength(provider, prefix) {
  var config = getAPIConfig(provider);

  if (!config) {
    return 0;
  }

  var result;

  if (!config.maxURL) {
    result = 0;
  } else {
    var maxHostLength = 0;
    config.resources.forEach(function (item) {
      var host = item;
      maxHostLength = Math.max(maxHostLength, host.length);
    });
    var url = prefix + ".json?icons=";
    result = config.maxURL - maxHostLength - config.path.length - url.length;
  }

  return result;
}

function shouldAbort(status) {
  return status === 404;
}

var prepare = function prepare(provider, prefix, icons) {
  var results = [];
  var maxLength = calculateMaxLength(provider, prefix);
  var type = "icons";
  var item = {
    type: type,
    provider: provider,
    prefix: prefix,
    icons: []
  };
  var length = 0;
  icons.forEach(function (name, index) {
    length += name.length + 1;

    if (length >= maxLength && index > 0) {
      results.push(item);
      item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
      };
      length = name.length;
    }

    item.icons.push(name);
  });
  results.push(item);
  return results;
};

function getPath(provider) {
  if (typeof provider === "string") {
    var config = getAPIConfig(provider);

    if (config) {
      return config.path;
    }
  }

  return "/";
}

var send = function send(host, params, callback) {
  if (!fetchModule) {
    callback("abort", 424);
    return;
  }

  var path = getPath(params.provider);

  switch (params.type) {
    case "icons":
      {
        var prefix = params.prefix;
        var icons = params.icons;
        var iconsList = icons.join(",");
        var urlParams = new URLSearchParams({
          icons: iconsList
        });
        path += prefix + ".json?" + urlParams.toString();
        break;
      }

    case "custom":
      {
        var uri = params.uri;
        path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
        break;
      }

    default:
      callback("abort", 400);
      return;
  }

  var defaultError = 503;
  fetchModule(host + path).then(function (response) {
    var status = response.status;

    if (status !== 200) {
      setTimeout(function () {
        callback(shouldAbort(status) ? "abort" : "next", status);
      });
      return;
    }

    defaultError = 501;
    return response.json();
  }).then(function (data) {
    if (_typeof(data) !== "object" || data === null) {
      setTimeout(function () {
        if (data === 404) {
          callback("abort", data);
        } else {
          callback("next", defaultError);
        }
      });
      return;
    }

    setTimeout(function () {
      callback("success", data);
    });
  }).catch(function () {
    callback("next", defaultError);
  });
};

var fetchAPIModule = {
  prepare: prepare,
  send: send
};

function sortIcons(icons) {
  var result = {
    loaded: [],
    missing: [],
    pending: []
  };
  var storage = /* @__PURE__ */Object.create(null);
  icons.sort(function (a, b) {
    if (a.provider !== b.provider) {
      return a.provider.localeCompare(b.provider);
    }

    if (a.prefix !== b.prefix) {
      return a.prefix.localeCompare(b.prefix);
    }

    return a.name.localeCompare(b.name);
  });
  var lastIcon = {
    provider: "",
    prefix: "",
    name: ""
  };
  icons.forEach(function (icon) {
    if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) {
      return;
    }

    lastIcon = icon;
    var provider = icon.provider;
    var prefix = icon.prefix;
    var name = icon.name;
    var providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */Object.create(null));
    var localStorage = providerStorage[prefix] || (providerStorage[prefix] = getStorage(provider, prefix));
    var list;

    if (name in localStorage.icons) {
      list = result.loaded;
    } else if (prefix === "" || localStorage.missing.has(name)) {
      list = result.missing;
    } else {
      list = result.pending;
    }

    var item = {
      provider: provider,
      prefix: prefix,
      name: name
    };
    list.push(item);
  });
  return result;
}

function removeCallback(storages, id) {
  storages.forEach(function (storage) {
    var items = storage.loaderCallbacks;

    if (items) {
      storage.loaderCallbacks = items.filter(function (row) {
        return row.id !== id;
      });
    }
  });
}

function updateCallbacks(storage) {
  if (!storage.pendingCallbacksFlag) {
    storage.pendingCallbacksFlag = true;
    setTimeout(function () {
      storage.pendingCallbacksFlag = false;
      var items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];

      if (!items.length) {
        return;
      }

      var hasPending = false;
      var provider = storage.provider;
      var prefix = storage.prefix;
      items.forEach(function (item) {
        var icons = item.icons;
        var oldLength = icons.pending.length;
        icons.pending = icons.pending.filter(function (icon) {
          if (icon.prefix !== prefix) {
            return true;
          }

          var name = icon.name;

          if (storage.icons[name]) {
            icons.loaded.push({
              provider: provider,
              prefix: prefix,
              name: name
            });
          } else if (storage.missing.has(name)) {
            icons.missing.push({
              provider: provider,
              prefix: prefix,
              name: name
            });
          } else {
            hasPending = true;
            return true;
          }

          return false;
        });

        if (icons.pending.length !== oldLength) {
          if (!hasPending) {
            removeCallback([storage], item.id);
          }

          item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
        }
      });
    });
  }
}

var idCounter = 0;

function storeCallback(callback, icons, pendingSources) {
  var id = idCounter++;
  var abort = removeCallback.bind(null, pendingSources, id);

  if (!icons.pending.length) {
    return abort;
  }

  var item = {
    id: id,
    icons: icons,
    callback: callback,
    abort: abort
  };
  pendingSources.forEach(function (storage) {
    (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
  });
  return abort;
}

function listToIcons(list) {
  var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var simpleNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var result = [];
  list.forEach(function (item) {
    var icon = typeof item === "string" ? stringToIcon(item, validate, simpleNames) : item;

    if (icon) {
      result.push(icon);
    }
  });
  return result;
} // src/config.ts


var defaultConfig = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: false,
  dataAfterTimeout: false
}; // src/query.ts

function sendQuery(config, payload, query, done) {
  var resourcesCount = config.resources.length;
  var startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
  var resources;

  if (config.random) {
    var list = config.resources.slice(0);
    resources = [];

    while (list.length > 1) {
      var nextIndex = Math.floor(Math.random() * list.length);
      resources.push(list[nextIndex]);
      list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
    }

    resources = resources.concat(list);
  } else {
    resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
  }

  var startTime = Date.now();
  var status = "pending";
  var queriesSent = 0;
  var lastError;
  var timer = null;
  var queue = [];
  var doneCallbacks = [];

  if (typeof done === "function") {
    doneCallbacks.push(done);
  }

  function resetTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function abort() {
    if (status === "pending") {
      status = "aborted";
    }

    resetTimer();
    queue.forEach(function (item) {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }

  function subscribe(callback, overwrite) {
    if (overwrite) {
      doneCallbacks = [];
    }

    if (typeof callback === "function") {
      doneCallbacks.push(callback);
    }
  }

  function getQueryStatus() {
    return {
      startTime: startTime,
      payload: payload,
      status: status,
      queriesSent: queriesSent,
      queriesPending: queue.length,
      subscribe: subscribe,
      abort: abort
    };
  }

  function failQuery() {
    status = "failed";
    doneCallbacks.forEach(function (callback) {
      callback(void 0, lastError);
    });
  }

  function clearQueue() {
    queue.forEach(function (item) {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }

  function moduleResponse(item, response, data) {
    var isError = response !== "success";
    queue = queue.filter(function (queued) {
      return queued !== item;
    });

    switch (status) {
      case "pending":
        break;

      case "failed":
        if (isError || !config.dataAfterTimeout) {
          return;
        }

        break;

      default:
        return;
    }

    if (response === "abort") {
      lastError = data;
      failQuery();
      return;
    }

    if (isError) {
      lastError = data;

      if (!queue.length) {
        if (!resources.length) {
          failQuery();
        } else {
          execNext();
        }
      }

      return;
    }

    resetTimer();
    clearQueue();

    if (!config.random) {
      var index = config.resources.indexOf(item.resource);

      if (index !== -1 && index !== config.index) {
        config.index = index;
      }
    }

    status = "completed";
    doneCallbacks.forEach(function (callback) {
      callback(data);
    });
  }

  function execNext() {
    if (status !== "pending") {
      return;
    }

    resetTimer();
    var resource = resources.shift();

    if (resource === void 0) {
      if (queue.length) {
        timer = setTimeout(function () {
          resetTimer();

          if (status === "pending") {
            clearQueue();
            failQuery();
          }
        }, config.timeout);
        return;
      }

      failQuery();
      return;
    }

    var item = {
      status: "pending",
      resource: resource,
      callback: function callback(status2, data) {
        moduleResponse(item, status2, data);
      }
    };
    queue.push(item);
    queriesSent++;
    timer = setTimeout(execNext, config.rotate);
    query(resource, payload, item.callback);
  }

  setTimeout(execNext);
  return getQueryStatus;
} // src/index.ts


function initRedundancy(cfg) {
  var config = _objectSpread(_objectSpread({}, defaultConfig), cfg);

  var queries = [];

  function cleanup() {
    queries = queries.filter(function (item) {
      return item().status === "pending";
    });
  }

  function query(payload, queryCallback, doneCallback) {
    var query2 = sendQuery(config, payload, queryCallback, function (data, error) {
      cleanup();

      if (doneCallback) {
        doneCallback(data, error);
      }
    });
    queries.push(query2);
    return query2;
  }

  function find(callback) {
    return queries.find(function (value) {
      return callback(value);
    }) || null;
  }

  var instance = {
    query: query,
    find: find,
    setIndex: function setIndex(index) {
      config.index = index;
    },
    getIndex: function getIndex() {
      return config.index;
    },
    cleanup: cleanup
  };
  return instance;
}

function emptyCallback$1() {}

var redundancyCache = /* @__PURE__ */Object.create(null);

function getRedundancyCache(provider) {
  if (!redundancyCache[provider]) {
    var config = getAPIConfig(provider);

    if (!config) {
      return;
    }

    var redundancy = initRedundancy(config);
    var cachedReundancy = {
      config: config,
      redundancy: redundancy
    };
    redundancyCache[provider] = cachedReundancy;
  }

  return redundancyCache[provider];
}

function sendAPIQuery(target, query, callback) {
  var redundancy;
  var send;

  if (typeof target === "string") {
    var api = getAPIModule(target);

    if (!api) {
      callback(void 0, 424);
      return emptyCallback$1;
    }

    send = api.send;
    var cached = getRedundancyCache(target);

    if (cached) {
      redundancy = cached.redundancy;
    }
  } else {
    var config = createAPIConfig(target);

    if (config) {
      redundancy = initRedundancy(config);
      var moduleKey = target.resources ? target.resources[0] : "";

      var _api2 = getAPIModule(moduleKey);

      if (_api2) {
        send = _api2.send;
      }
    }
  }

  if (!redundancy || !send) {
    callback(void 0, 424);
    return emptyCallback$1;
  }

  return redundancy.query(query, send, callback)().abort;
}

var browserCacheVersion = "iconify2";
var browserCachePrefix = "iconify";
var browserCacheCountKey = browserCachePrefix + "-count";
var browserCacheVersionKey = browserCachePrefix + "-version";
var browserStorageHour = 36e5;
var browserStorageCacheExpiration = 168;

function getStoredItem(func, key) {
  try {
    return func.getItem(key);
  } catch (err) {}
}

function setStoredItem(func, key, value) {
  try {
    func.setItem(key, value);
    return true;
  } catch (err) {}
}

function removeStoredItem(func, key) {
  try {
    func.removeItem(key);
  } catch (err) {}
}

function setBrowserStorageItemsCount(storage, value) {
  return setStoredItem(storage, browserCacheCountKey, value.toString());
}

function getBrowserStorageItemsCount(storage) {
  return parseInt(getStoredItem(storage, browserCacheCountKey)) || 0;
}

var browserStorageConfig = {
  local: true,
  session: true
};
var browserStorageEmptyItems = {
  local: /* @__PURE__ */new Set(),
  session: /* @__PURE__ */new Set()
};
var browserStorageStatus = false;

function setBrowserStorageStatus(status) {
  browserStorageStatus = status;
}

var _window = typeof window === "undefined" ? {} : window;

function getBrowserStorage(key) {
  var attr = key + "Storage";

  try {
    if (_window && _window[attr] && typeof _window[attr].length === "number") {
      return _window[attr];
    }
  } catch (err) {}

  browserStorageConfig[key] = false;
}

function iterateBrowserStorage(key, callback) {
  var func = getBrowserStorage(key);

  if (!func) {
    return;
  }

  var version = getStoredItem(func, browserCacheVersionKey);

  if (version !== browserCacheVersion) {
    if (version) {
      var total2 = getBrowserStorageItemsCount(func);

      for (var i = 0; i < total2; i++) {
        removeStoredItem(func, browserCachePrefix + i.toString());
      }
    }

    setStoredItem(func, browserCacheVersionKey, browserCacheVersion);
    setBrowserStorageItemsCount(func, 0);
    return;
  }

  var minTime = Math.floor(Date.now() / browserStorageHour) - browserStorageCacheExpiration;

  var parseItem = function parseItem(index) {
    var name = browserCachePrefix + index.toString();
    var item = getStoredItem(func, name);

    if (typeof item !== "string") {
      return;
    }

    try {
      var data = JSON.parse(item);

      if (_typeof(data) === "object" && typeof data.cached === "number" && data.cached > minTime && typeof data.provider === "string" && _typeof(data.data) === "object" && typeof data.data.prefix === "string" && callback(data, index)) {
        return true;
      }
    } catch (err) {}

    removeStoredItem(func, name);
  };

  var total = getBrowserStorageItemsCount(func);

  for (var _i = total - 1; _i >= 0; _i--) {
    if (!parseItem(_i)) {
      if (_i === total - 1) {
        total--;
        setBrowserStorageItemsCount(func, total);
      } else {
        browserStorageEmptyItems[key].add(_i);
      }
    }
  }
}

function initBrowserStorage() {
  if (browserStorageStatus) {
    return;
  }

  setBrowserStorageStatus(true);

  for (var key in browserStorageConfig) {
    iterateBrowserStorage(key, function (item) {
      var iconSet = item.data;
      var provider = item.provider;
      var prefix = iconSet.prefix;
      var storage = getStorage(provider, prefix);

      if (!addIconSet(storage, iconSet).length) {
        return false;
      }

      var lastModified = iconSet.lastModified || -1;
      storage.lastModifiedCached = storage.lastModifiedCached ? Math.min(storage.lastModifiedCached, lastModified) : lastModified;
      return true;
    });
  }
}

function updateLastModified(storage, lastModified) {
  var lastValue = storage.lastModifiedCached;

  if (lastValue && lastValue >= lastModified) {
    return lastValue === lastModified;
  }

  storage.lastModifiedCached = lastModified;

  if (lastValue) {
    for (var key in browserStorageConfig) {
      iterateBrowserStorage(key, function (item) {
        var iconSet = item.data;
        return item.provider !== storage.provider || iconSet.prefix !== storage.prefix || iconSet.lastModified === lastModified;
      });
    }
  }

  return true;
}

function storeInBrowserStorage(storage, data) {
  if (!browserStorageStatus) {
    initBrowserStorage();
  }

  function store(key) {
    var func;

    if (!browserStorageConfig[key] || !(func = getBrowserStorage(key))) {
      return;
    }

    var set = browserStorageEmptyItems[key];
    var index;

    if (set.size) {
      set.delete(index = Array.from(set).shift());
    } else {
      index = getBrowserStorageItemsCount(func);

      if (!setBrowserStorageItemsCount(func, index + 1)) {
        return;
      }
    }

    var item = {
      cached: Math.floor(Date.now() / browserStorageHour),
      provider: storage.provider,
      data: data
    };
    return setStoredItem(func, browserCachePrefix + index.toString(), JSON.stringify(item));
  }

  if (data.lastModified && !updateLastModified(storage, data.lastModified)) {
    return;
  }

  if (!Object.keys(data.icons).length) {
    return;
  }

  if (data.not_found) {
    data = Object.assign({}, data);
    delete data.not_found;
  }

  if (!store("local")) {
    store("session");
  }
}

function emptyCallback() {}

function loadedNewIcons(storage) {
  if (!storage.iconsLoaderFlag) {
    storage.iconsLoaderFlag = true;
    setTimeout(function () {
      storage.iconsLoaderFlag = false;
      updateCallbacks(storage);
    });
  }
}

function loadNewIcons(storage, icons) {
  if (!storage.iconsToLoad) {
    storage.iconsToLoad = icons;
  } else {
    storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
  }

  if (!storage.iconsQueueFlag) {
    storage.iconsQueueFlag = true;
    setTimeout(function () {
      storage.iconsQueueFlag = false;
      var provider = storage.provider,
          prefix = storage.prefix;
      var icons2 = storage.iconsToLoad;
      delete storage.iconsToLoad;
      var api;

      if (!icons2 || !(api = getAPIModule(provider))) {
        return;
      }

      var params = api.prepare(provider, prefix, icons2);
      params.forEach(function (item) {
        sendAPIQuery(provider, item, function (data) {
          if (_typeof(data) !== "object") {
            item.icons.forEach(function (name) {
              storage.missing.add(name);
            });
          } else {
            try {
              var parsed = addIconSet(storage, data);

              if (!parsed.length) {
                return;
              }

              var pending = storage.pendingIcons;

              if (pending) {
                parsed.forEach(function (name) {
                  pending.delete(name);
                });
              }

              storeInBrowserStorage(storage, data);
            } catch (err) {
              console.error(err);
            }
          }

          loadedNewIcons(storage);
        });
      });
    });
  }
}

var loadIcons = function loadIcons(icons, callback) {
  var cleanedIcons = listToIcons(icons, true, allowSimpleNames());
  var sortedIcons = sortIcons(cleanedIcons);

  if (!sortedIcons.pending.length) {
    var callCallback = true;

    if (callback) {
      setTimeout(function () {
        if (callCallback) {
          callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, emptyCallback);
        }
      });
    }

    return function () {
      callCallback = false;
    };
  }

  var newIcons = /* @__PURE__ */Object.create(null);
  var sources = [];
  var lastProvider, lastPrefix;
  sortedIcons.pending.forEach(function (icon) {
    var provider = icon.provider,
        prefix = icon.prefix;

    if (prefix === lastPrefix && provider === lastProvider) {
      return;
    }

    lastProvider = provider;
    lastPrefix = prefix;
    sources.push(getStorage(provider, prefix));
    var providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */Object.create(null));

    if (!providerNewIcons[prefix]) {
      providerNewIcons[prefix] = [];
    }
  });
  sortedIcons.pending.forEach(function (icon) {
    var provider = icon.provider,
        prefix = icon.prefix,
        name = icon.name;
    var storage = getStorage(provider, prefix);
    var pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */new Set());

    if (!pendingQueue.has(name)) {
      pendingQueue.add(name);
      newIcons[provider][prefix].push(name);
    }
  });
  sources.forEach(function (storage) {
    var provider = storage.provider,
        prefix = storage.prefix;

    if (newIcons[provider][prefix].length) {
      loadNewIcons(storage, newIcons[provider][prefix]);
    }
  });
  return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};

var loadIcon = function loadIcon(icon) {
  return new Promise(function (fulfill, reject) {
    var iconObj = typeof icon === "string" ? stringToIcon(icon, true) : icon;

    if (!iconObj) {
      reject(icon);
      return;
    }

    loadIcons([iconObj || icon], function (loaded) {
      if (loaded.length && iconObj) {
        var data = getIconData(iconObj);

        if (data) {
          fulfill(_objectSpread(_objectSpread({}, defaultIconProps), data));
          return;
        }
      }

      reject(icon);
    });
  });
};

function toggleBrowserCache(storage, value) {
  switch (storage) {
    case "local":
    case "session":
      browserStorageConfig[storage] = value;
      break;

    case "all":
      for (var key in browserStorageConfig) {
        browserStorageConfig[key] = value;
      }

      break;
  }
}

function mergeCustomisations(defaults, item) {
  var result = _objectSpread({}, defaults);

  for (var key in item) {
    var value = item[key];

    var valueType = _typeof(value);

    if (key in defaultIconSizeCustomisations) {
      if (value === null || value && (valueType === "string" || valueType === "number")) {
        result[key] = value;
      }
    } else if (valueType === _typeof(result[key])) {
      result[key] = key === "rotate" ? value % 4 : value;
    }
  }

  return result;
}

var separator = /[\s,]+/;

function flipFromString(custom, flip) {
  flip.split(separator).forEach(function (str) {
    var value = str.trim();

    switch (value) {
      case "horizontal":
        custom.hFlip = true;
        break;

      case "vertical":
        custom.vFlip = true;
        break;
    }
  });
}

function rotateFromString(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var units = value.replace(/^-?[0-9.]*/, "");

  function cleanup(value2) {
    while (value2 < 0) {
      value2 += 4;
    }

    return value2 % 4;
  }

  if (units === "") {
    var num = parseInt(value);
    return isNaN(num) ? 0 : cleanup(num);
  } else if (units !== value) {
    var split = 0;

    switch (units) {
      case "%":
        split = 25;
        break;

      case "deg":
        split = 90;
    }

    if (split) {
      var _num = parseFloat(value.slice(0, value.length - units.length));

      if (isNaN(_num)) {
        return 0;
      }

      _num = _num / split;
      return _num % 1 === 0 ? cleanup(_num) : 0;
    }
  }

  return defaultValue;
}

function iconToHTML(body, attributes) {
  var renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';

  for (var attr in attributes) {
    renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
  }

  return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}

function encodeSVGforURL(svg) {
  return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}

function svgToURL(svg) {
  return 'url("data:image/svg+xml,' + encodeSVGforURL(svg) + '")';
}

var defaultExtendedIconCustomisations = _objectSpread(_objectSpread({}, defaultIconCustomisations), {}, {
  inline: false
});
/**
 * Default SVG attributes
 */


var svgDefaults = {
  'xmlns': 'http://www.w3.org/2000/svg',
  'xmlnsXlink': 'http://www.w3.org/1999/xlink',
  'aria-hidden': true,
  'role': 'img'
};
/**
 * Style modes
 */

var commonProps = {
  display: 'inline-block'
};
var monotoneProps = {
  backgroundColor: 'currentColor'
};
var coloredProps = {
  backgroundColor: 'transparent'
}; // Dynamically add common props to variables above

var propsToAdd = {
  Image: 'var(--svg)',
  Repeat: 'no-repeat',
  Size: '100% 100%'
};
var propsToAddTo = {
  webkitMask: monotoneProps,
  mask: monotoneProps,
  background: coloredProps
};

for (var prefix in propsToAddTo) {
  var list = propsToAddTo[prefix];

  for (var prop in propsToAdd) {
    list[prefix + prop] = propsToAdd[prop];
  }
}
/**
 * Default values for customisations for inline icon
 */


var inlineDefaults = _objectSpread(_objectSpread({}, defaultExtendedIconCustomisations), {}, {
  inline: true
});
/**
 * Fix size: add 'px' to numbers
 */


function fixSize(value) {
  return value + (value.match(/^[-0-9.]+$/) ? 'px' : '');
}
/**
 * Render icon
 */


var _render = function render( // Icon must be validated before calling this function
icon, // Partial properties
props, // True if icon should have vertical-align added
inline, // Optional reference for SVG/SPAN, extracted by React.forwardRef()
ref) {
  // Get default properties
  var defaultProps = inline ? inlineDefaults : defaultExtendedIconCustomisations; // Get all customisations

  var customisations = mergeCustomisations(defaultProps, props); // Check mode

  var mode = props.mode || 'svg'; // Create style

  var style = {};
  var customStyle = props.style || {}; // Create SVG component properties

  var componentProps = _objectSpread(_objectSpread({}, mode === 'svg' ? svgDefaults : {}), {}, {
    ref: ref
  }); // Get element properties


  for (var key in props) {
    var value = props[key];

    if (value === void 0) {
      continue;
    }

    switch (key) {
      // Properties to ignore
      case 'icon':
      case 'style':
      case 'children':
      case 'onLoad':
      case 'mode':
      case '_ref':
      case '_inline':
        break;
      // Boolean attributes

      case 'inline':
      case 'hFlip':
      case 'vFlip':
        customisations[key] = value === true || value === 'true' || value === 1;
        break;
      // Flip as string: 'horizontal,vertical'

      case 'flip':
        if (typeof value === 'string') {
          flipFromString(customisations, value);
        }

        break;
      // Color: copy to style

      case 'color':
        style.color = value;
        break;
      // Rotation as string

      case 'rotate':
        if (typeof value === 'string') {
          customisations[key] = rotateFromString(value);
        } else if (typeof value === 'number') {
          customisations[key] = value;
        }

        break;
      // Remove aria-hidden

      case 'ariaHidden':
      case 'aria-hidden':
        if (value !== true && value !== 'true') {
          delete componentProps['aria-hidden'];
        }

        break;
      // Copy missing property if it does not exist in customisations

      default:
        if (defaultProps[key] === void 0) {
          componentProps[key] = value;
        }

    }
  } // Generate icon


  var item = iconToSVG(icon, customisations);
  var renderAttribs = item.attributes; // Inline display

  if (customisations.inline) {
    style.verticalAlign = '-0.125em';
  }

  if (mode === 'svg') {
    // Add style
    componentProps.style = _objectSpread(_objectSpread({}, style), customStyle); // Add icon stuff

    Object.assign(componentProps, renderAttribs); // Counter for ids based on "id" property to render icons consistently on server and client

    var localCounter = 0;
    var id = props.id;

    if (typeof id === 'string') {
      // Convert '-' to '_' to avoid errors in animations
      id = id.replace(/-/g, '_');
    } // Add icon stuff


    componentProps.dangerouslySetInnerHTML = {
      __html: replaceIDs(item.body, id ? function () {
        return id + 'ID' + localCounter++;
      } : 'iconifyReact')
    };
    return /*#__PURE__*/React.createElement('svg', componentProps);
  } // Render <span> with style


  var body = icon.body,
      width = icon.width,
      height = icon.height;
  var useMask = mode === 'mask' || (mode === 'bg' ? false : body.indexOf('currentColor') !== -1); // Generate SVG

  var html = iconToHTML(body, _objectSpread(_objectSpread({}, renderAttribs), {}, {
    width: width + '',
    height: height + ''
  })); // Generate style

  componentProps.style = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style), {}, {
    '--svg': svgToURL(html),
    'width': fixSize(renderAttribs.width),
    'height': fixSize(renderAttribs.height)
  }, commonProps), useMask ? monotoneProps : coloredProps), customStyle);
  return /*#__PURE__*/React.createElement('span', componentProps);
};
/**
 * Enable cache
 */


function enableCache(storage) {
  toggleBrowserCache(storage, true);
}
/**
 * Disable cache
 */


function disableCache(storage) {
  toggleBrowserCache(storage, false);
}
/**
 * Initialise stuff
 */
// Enable short names


allowSimpleNames(true); // Set API module

setAPIModule('', fetchAPIModule);
/**
 * Browser stuff
 */

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // Set cache and load existing cache
  initBrowserStorage();
  var _window2 = window; // Load icons from global "IconifyPreload"

  if (_window2.IconifyPreload !== void 0) {
    var preload = _window2.IconifyPreload;
    var err = 'Invalid IconifyPreload syntax.';

    if (_typeof(preload) === 'object' && preload !== null) {
      (preload instanceof Array ? preload : [preload]).forEach(function (item) {
        try {
          if ( // Check if item is an object and not null/array
          _typeof(item) !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
          _typeof(item.icons) !== 'object' || typeof item.prefix !== 'string' || // Add icon set
          !addCollection(item)) {
            console.error(err);
          }
        } catch (e) {
          console.error(err);
        }
      });
    }
  } // Set API from global "IconifyProviders"


  if (_window2.IconifyProviders !== void 0) {
    var providers = _window2.IconifyProviders;

    if (_typeof(providers) === 'object' && providers !== null) {
      for (var key in providers) {
        var _err = 'IconifyProviders[' + key + '] is invalid.';

        try {
          var value = providers[key];

          if (_typeof(value) !== 'object' || !value || value.resources === void 0) {
            continue;
          }

          if (!addAPIProvider(key, value)) {
            console.error(_err);
          }
        } catch (e) {
          console.error(_err);
        }
      }
    }
  }
}

var IconComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(IconComponent, _React$Component);

  var _super = _createSuper(IconComponent);

  function IconComponent(props) {
    var _this;

    _classCallCheck(this, IconComponent);

    _this = _super.call(this, props);
    _this.state = {
      // Render placeholder before component is mounted
      icon: null
    };
    return _this;
  }
  /**
   * Abort loading icon
   */


  _createClass(IconComponent, [{
    key: "_abortLoading",
    value: function _abortLoading() {
      if (this._loading) {
        this._loading.abort();

        this._loading = null;
      }
    }
    /**
     * Update state
     */

  }, {
    key: "_setData",
    value: function _setData(icon) {
      if (this.state.icon !== icon) {
        this.setState({
          icon: icon
        });
      }
    }
    /**
     * Check if icon should be loaded
     */

  }, {
    key: "_checkIcon",
    value: function _checkIcon(changed) {
      var state = this.state;
      var icon = this.props.icon; // Icon is an object

      if (_typeof(icon) === 'object' && icon !== null && typeof icon.body === 'string') {
        // Stop loading
        this._icon = '';

        this._abortLoading();

        if (changed || state.icon === null) {
          // Set data if it was changed
          this._setData({
            data: icon
          });
        }

        return;
      } // Invalid icon?


      var iconName;

      if (typeof icon !== 'string' || (iconName = stringToIcon(icon, false, true)) === null) {
        this._abortLoading();

        this._setData(null);

        return;
      } // Load icon


      var data = getIconData(iconName);

      if (!data) {
        // Icon data is not available
        if (!this._loading || this._loading.name !== icon) {
          // New icon to load
          this._abortLoading();

          this._icon = '';

          this._setData(null);

          if (data !== null) {
            // Icon was not loaded
            this._loading = {
              name: icon,
              abort: loadIcons([iconName], this._checkIcon.bind(this, false))
            };
          }
        }

        return;
      } // Icon data is available


      if (this._icon !== icon || state.icon === null) {
        // New icon or icon has been loaded
        this._abortLoading();

        this._icon = icon; // Add classes

        var classes = ['iconify'];

        if (iconName.prefix !== '') {
          classes.push('iconify--' + iconName.prefix);
        }

        if (iconName.provider !== '') {
          classes.push('iconify--' + iconName.provider);
        } // Set data


        this._setData({
          data: data,
          classes: classes
        });

        if (this.props.onLoad) {
          this.props.onLoad(icon);
        }
      }
    }
    /**
     * Component mounted
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkIcon(false);
    }
    /**
     * Component updated
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.icon !== this.props.icon) {
        this._checkIcon(true);
      }
    }
    /**
     * Abort loading
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._abortLoading();
    }
    /**
     * Render
     */

  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var icon = this.state.icon;

      if (icon === null) {
        // Render placeholder
        return props.children ? props.children : /*#__PURE__*/React.createElement('span', {});
      } // Add classes


      var newProps = props;

      if (icon.classes) {
        newProps = _objectSpread(_objectSpread({}, props), {}, {
          className: (typeof props.className === 'string' ? props.className + ' ' : '') + icon.classes.join(' ')
        });
      } // Render icon


      return _render(_objectSpread(_objectSpread({}, defaultIconProps), icon.data), newProps, props._inline, props._ref);
    }
  }]);

  return IconComponent;
}(React.Component);
/**
 * Block icon
 *
 * @param props - Component properties
 */


var Icon = /*#__PURE__*/React.forwardRef(function Icon(props, ref) {
  var newProps = _objectSpread(_objectSpread({}, props), {}, {
    _ref: ref,
    _inline: false
  });

  return /*#__PURE__*/React.createElement(IconComponent, newProps);
});
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */

var InlineIcon = /*#__PURE__*/React.forwardRef(function InlineIcon(props, ref) {
  var newProps = _objectSpread(_objectSpread({}, props), {}, {
    _ref: ref,
    _inline: true
  });

  return /*#__PURE__*/React.createElement(IconComponent, newProps);
});
/**
 * Internal API
 */

var _api = {
  getAPIConfig: getAPIConfig,
  setAPIModule: setAPIModule,
  sendAPIQuery: sendAPIQuery,
  setFetch: setFetch,
  getFetch: getFetch,
  listAPIProviders: listAPIProviders
};
export { Icon, InlineIcon, _api, addAPIProvider, addCollection, addIcon, iconToSVG as buildIcon, calculateSize, disableCache, enableCache, getIcon, iconExists, listIcons, loadIcon, loadIcons, replaceIDs };